import { ApplicationRef, inject } from '@angular/core';
import { first, Observable } from 'rxjs';

export const isApplicationStable = (): Observable<boolean> => {
  const applicationRef = inject(ApplicationRef);

  return applicationRef.isStable.pipe(first((isStable) => isStable));
};
